import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content type4" };
import { onMounted, onUnmounted, } from 'vue';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { tableHeader } from '@/constants/storeWorkProcess';
import BrgPagination from '@/components/BrgPagination.vue';
import { storeToRefs } from 'pinia';
import { i18n } from '@/locales';
import { alertActionType } from '@/vuex-store/alert/actions';
import { autoLcStoreWorkProcess } from '@/locales/ko/views/store_work_process';
import { prevData } from '@/pinia/storeWorkProcess';
import { pStore } from '@/pinia';
import Select from '@/components/Form/Select.vue';
import { pageSizeOptionList } from '@/constants';
import TotalCount from '@/components/TotalCount.vue';
import Item from './Item.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // PAGE: 상점 업무처리
        const lc = autoLcStoreWorkProcess();
        const piniaStore = pStore.piniaStoreWorkProcess;
        const { itemList, paginationData, filterOption, noticeTotalCount, } = storeToRefs(piniaStore);
        const getTableHeader = () => tableHeader;
        const _confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        const onDelete = async (id) => {
            const isConfirmOk = await _confirm({
                headerTitle: lc('delete.head'),
                bodyContent: lc('delete.body_with_id', {
                    id,
                }),
            });
            if (!isConfirmOk) {
                return;
            }
            try {
                await piniaStore.deleteNotice(id);
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                piniaStore.getItemList();
            }
            catch (error) {
                console.log('workerNotice/deleteNotice', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 페이지 개수 변경 핸들러
         */
        const handleChangeSelect = (filterType) => async (value) => {
            const oldValue = filterOption.value.pageNumber;
            try {
                filterOption.value.pageNumber = 1;
                filterOption.value[filterType] = value;
                prevData.pageSizeType = value;
                await piniaStore.getItemList();
            }
            catch (error) {
                console.log('workerNotice/handleChangeSelect', error);
                filterOption.value.pageNumber = oldValue;
            }
        };
        /**
         * 페이지네이션 클릭 핸들러
         */
        const handleUpdateModelValue = (value) => {
            filterOption.value.pageNumber = value;
            piniaStore.getItemList();
        };
        onMounted(async () => {
            try {
                if (prevData.pageNumber) {
                    filterOption.value.pageNumber = prevData.pageNumber;
                    prevData.pageNumber = 0;
                }
                if (prevData.pageSizeType) {
                    filterOption.value.pageSizeType = prevData.pageSizeType;
                    prevData.pageSizeType = '';
                }
                await piniaStore.getItemList();
            }
            catch (error) {
                vuexStore.dispatch(snackbarActionType.showError, error.data.error);
            }
        });
        onUnmounted(() => {
            piniaStore.$reset();
        });
        return (_ctx, _cache) => {
            const _component_v_data_table_server = _resolveComponent("v-data-table-server");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(TotalCount, null, {
                    default: _withCtx(() => [
                        _createTextVNode(" 총 " + _toDisplayString(_unref(noticeTotalCount)) + " 건 ", 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_data_table_server, {
                    hover: "",
                    "hide-default-footer": "",
                    "fixed-header": "",
                    density: "comfortable",
                    class: "brg-table",
                    headers: getTableHeader(),
                    items: _unref(itemList),
                    "items-per-page": 1,
                    "items-length": -1
                }, {
                    [`item`]: _withCtx(({ item }) => [
                        _createVNode(Item, {
                            item: item,
                            onOnDelete: onDelete
                        }, null, 8 /* PROPS */, ["item"])
                    ]),
                    _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "items"]),
                _createVNode(BrgPagination, {
                    "model-value": _unref(filterOption).pageNumber,
                    "onUpdate:modelValue": handleUpdateModelValue,
                    length: _unref(paginationData).pages
                }, {
                    start: _withCtx(() => _cache[0] || (_cache[0] = [])),
                    end: _withCtx(() => [
                        _createCommentVNode(" pageSize filter "),
                        _createVNode(Select, {
                            class: "page-size-wrapper mini",
                            value: _unref(filterOption).pageSizeType,
                            items: _unref(pageSizeOptionList),
                            "on-change": handleChangeSelect('pageSizeType')
                        }, null, 8 /* PROPS */, ["value", "items", "on-change"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["model-value", "length"])
            ]));
        };
    }
});
